import { useEffect, useRef } from 'react';

function usePortal(id = null) {
    const rootElement = useRef();

    useEffect(() => {
        const existingParent = document.querySelector(`#${id}`);
        const parentElement = existingParent || createModalRoot(id);

        if (!existingParent) {
            addElement(parentElement);
        }

        parentElement.appendChild(rootElement.current);

        return () => {
            rootElement.current.remove();
            if (!parentElement.childElementCount) {
                parentElement.remove();
            }
        };
    }, [id]);

    function getRootElement() {
        if (!rootElement.curent) {
            rootElement.current = document.createElement('div');
        }
        return rootElement.current;
    }

    return getRootElement();
}

function createModalRoot(id) {
    const rootDiv = document.createElement('div');
    rootDiv.setAttribute('id', id);
    return rootDiv;
}

function addElement(element) {
    document.body.insertBefore(
        element,
        document.body.lastElementChild.nextElementSibling
    );
}

export default usePortal;